/*
* Created on Thu Oct 12 2023 10:17:58 AM
*
* ***************************************************************************************
* Copyright (c) AVPS Technologies Inc 2023 
*
* All Rights Reserved
* Unpublished rights are reserved under the copyright laws of the United States.
* The software contained in this media is proprietary to and embodies confidential
* the technology of AVPS Technologies Inc. Possession, use, duplication or
* dissemination of the software and media is authorized only pursuant to a valid
* written license from AVPS Technologies Inc.
*
* The above copyright notice and this permission notice shall be included in
* all copies or substantial portions of the Software.
*
* RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
* is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
* 252.227-7013 or in FAR 52.227-19, as applicable.
****************************************************************************************
*/
import { useNavigate } from 'react-router-dom';

const SkeletonLine = ({ className = "" }) => (
  <div className={`animate-pulse rounded bg-slate-200 ${className}`.trim()} />
);

const formatLegacyPrice = (content = {}) => `${content.currency === 'USD' ? '$' : '₹'} ${content.price}`;

export function Media(props) {
  const navigate = useNavigate();
  const { id, src, content = {}, paid = [] } = props;
  const paidItems = Array.isArray(paid) ? paid : [];
  const hasPurchased = paidItems.some((item) => item?.courseCode === content?.courseCode);

  const handleCart = () => {
    navigate('/product-info', { state: { content, src, id } });
  };

  const loadingCard = (
    <div className="space-y-2 p-2">
      <SkeletonLine className="h-4 w-full" />
      <SkeletonLine className="h-4 w-3/5" />
    </div>
  );

  const courseDescription = content?.courseDescription || "";
  const shortDescription = courseDescription.length > 50
    ? `${courseDescription.slice(0, 50)}...`
    : courseDescription;

  const availableCard = content?.courseName ? (
    <button
      type="button"
      className="h-[260px] w-full overflow-hidden border-0 bg-white p-4 text-left transition hover:bg-sky-50 hover:opacity-80"
      onClick={handleCart}
    >
      {src ? (
        <img
          alt={content.courseName}
          className="h-[118px] w-[180px] object-cover"
          loading="lazy"
          src={src}
        />
      ) : (
        <SkeletonLine className="h-40 w-full" />
      )}
      <span className="block pt-3 text-sm font-bold capitalize text-slate-900">
        {content.courseName}
      </span>
      <span className="block max-h-[60px] overflow-hidden text-ellipsis text-xs text-slate-500">
        {shortDescription}
      </span>
      <span className="block text-xs text-slate-500">{content.skillLevel}</span>
      <span className="block pt-3 text-sm font-bold text-slate-900">{formatLegacyPrice(content)}</span>
    </button>
  ) : loadingCard;

  const purchasedCard = content?.courseName ? (
    <div className="h-[240px] overflow-hidden border-0 bg-white p-4 transition hover:bg-sky-50 hover:opacity-80">
      <span className="mt-5 block text-sm font-bold capitalize text-slate-900">
        {content.courseName}
      </span>
      <span className="block max-h-[60px] overflow-hidden text-ellipsis text-xs text-slate-500">
        {shortDescription}
      </span>
      <span className="block text-xs text-slate-500">{content.skillLevel}</span>
      <span className="block pt-3 text-sm font-bold text-slate-900">{formatLegacyPrice(content)}</span>
      <span className="mt-3 block text-xs text-slate-500">You have purchased already</span>
    </div>
  ) : loadingCard;

  return (
    <article className="my-5 mr-3 w-[210px] rounded bg-white shadow-lg" id={id}>
      {hasPurchased ? purchasedCard : availableCard}
    </article>
  );
}
